// Curriculum data for "Семь Ступенек: Счёт" (Seven Steps: Counting)
// Based on Polyakov's counting methodology

export const BLOCKS = [
  {
    id: 1,
    title: "Узнаём 1-3",
    titleEn: "Recognize 1-3",
    description: "Учимся быстро видеть количество 1, 2 и 3",
    descriptionEn: "Learn to quickly see quantities 1, 2, and 3",
    targetNumbers: [1, 2, 3],
    completionThreshold: 80,
    color: "cube-1",
    icon: "sparkles"
  },
  {
    id: 2,
    title: "Узнаём 4-5",
    titleEn: "Recognize 4-5",
    description: "Учимся видеть 4 и 5 как группы",
    descriptionEn: "Learn to see 4 and 5 as grouped patterns",
    targetNumbers: [1, 2, 3, 4, 5],
    completionThreshold: 80,
    color: "cube-2",
    icon: "eye"
  },
  {
    id: 3,
    title: "Число и цифра",
    titleEn: "Number & Numeral",
    description: "Соединяем количество и цифру",
    descriptionEn: "Connect quantity with numeral",
    targetNumbers: [1, 2, 3, 4, 5],
    completionThreshold: 85,
    color: "cube-3",
    icon: "link"
  },
  {
    id: 4,
    title: "Прибавляем и убавляем",
    titleEn: "Add & Remove",
    description: "Кубики приходят и уходят",
    descriptionEn: "Cubes come and go",
    targetNumbers: [1, 2, 3, 4, 5],
    completionThreshold: 80,
    color: "cube-4",
    icon: "plus-minus"
  },
  {
    id: 5,
    title: "Считаем в уме",
    titleEn: "Mental Math",
    description: "Простое сложение и вычитание в уме",
    descriptionEn: "Simple addition and subtraction in your head",
    targetNumbers: [1, 2, 3, 4, 5],
    completionThreshold: 80,
    color: "cube-5",
    icon: "brain"
  }
];

export const LESSONS = [
  // Block 1: Recognize 1-3
  {
    id: 1,
    blockId: 1,
    title: "Один и два",
    description: "Учимся видеть 1 и 2 кубика",
    exercises: [
      { type: "see-and-choose", count: 1, options: [1, 2] },
      { type: "see-and-choose", count: 2, options: [1, 2] },
      { type: "see-and-choose", count: 1, options: [1, 2, 3] },
      { type: "see-and-choose", count: 2, options: [1, 2, 3] },
      { type: "see-and-choose", count: 2, options: [1, 2] },
    ]
  },
  {
    id: 2,
    blockId: 1,
    title: "Добавляем три",
    description: "Теперь учимся видеть 3 кубика",
    exercises: [
      { type: "see-and-choose", count: 2, options: [1, 2, 3] },
      { type: "see-and-choose", count: 3, options: [1, 2, 3] },
      { type: "see-and-choose", count: 1, options: [1, 2, 3] },
      { type: "see-and-choose", count: 3, options: [2, 3, 4] },
      { type: "see-and-choose", count: 2, options: [1, 2, 3] },
    ]
  },
  {
    id: 3,
    blockId: 1,
    title: "Один, два, три!",
    description: "Повторяем все три числа",
    exercises: [
      { type: "see-and-choose", count: 1, options: [1, 2, 3] },
      { type: "see-and-choose", count: 3, options: [1, 2, 3] },
      { type: "compare-groups", left: 1, right: 2, question: "more" },
      { type: "see-and-choose", count: 2, options: [1, 2, 3] },
      { type: "compare-groups", left: 3, right: 2, question: "more" },
    ]
  },
  
  // Block 2: Recognize 4-5
  {
    id: 4,
    blockId: 2,
    title: "Узнаём четыре",
    description: "Четыре - это квадрат из кубиков",
    exercises: [
      { type: "see-and-choose", count: 3, options: [2, 3, 4] },
      { type: "see-and-choose", count: 4, options: [3, 4, 5] },
      { type: "see-and-choose", count: 4, options: [2, 3, 4] },
      { type: "compare-groups", left: 4, right: 3, question: "more" },
      { type: "see-and-choose", count: 4, options: [3, 4, 5] },
    ]
  },
  {
    id: 5,
    blockId: 2,
    title: "Узнаём пять",
    description: "Пять - это 4 и ещё 1",
    exercises: [
      { type: "see-and-choose", count: 4, options: [3, 4, 5] },
      { type: "see-and-choose", count: 5, options: [3, 4, 5] },
      { type: "see-and-choose", count: 5, options: [4, 5] },
      { type: "compare-groups", left: 5, right: 4, question: "more" },
      { type: "see-and-choose", count: 5, options: [3, 4, 5] },
    ]
  },
  {
    id: 6,
    blockId: 2,
    title: "От одного до пяти",
    description: "Повторяем все пять чисел",
    exercises: [
      { type: "see-and-choose", count: 2, options: [1, 2, 3, 4] },
      { type: "see-and-choose", count: 5, options: [3, 4, 5] },
      { type: "see-and-choose", count: 3, options: [2, 3, 4] },
      { type: "compare-groups", left: 2, right: 4, question: "less" },
      { type: "see-and-choose", count: 4, options: [2, 3, 4, 5] },
    ]
  },
  
  // Block 3: Quantity ↔ Numeral Mapping
  {
    id: 7,
    blockId: 3,
    title: "Цифры 1, 2, 3",
    description: "Соединяем кубики и цифры",
    exercises: [
      { type: "match-group-to-number", count: 2, options: [1, 2, 3] },
      { type: "match-number-to-group", number: 3, options: [2, 3, 4] },
      { type: "match-group-to-number", count: 1, options: [1, 2] },
      { type: "match-number-to-group", number: 2, options: [1, 2, 3] },
      { type: "match-group-to-number", count: 3, options: [2, 3, 4] },
    ]
  },
  {
    id: 8,
    blockId: 3,
    title: "Цифры 4 и 5",
    description: "Теперь добавляем 4 и 5",
    exercises: [
      { type: "match-group-to-number", count: 4, options: [3, 4, 5] },
      { type: "match-number-to-group", number: 5, options: [3, 4, 5] },
      { type: "match-group-to-number", count: 5, options: [4, 5] },
      { type: "match-number-to-group", number: 4, options: [2, 3, 4] },
      { type: "match-group-to-number", count: 3, options: [2, 3, 4, 5] },
    ]
  },
  {
    id: 9,
    blockId: 3,
    title: "Все цифры до 5",
    description: "Мастерим связь числа и цифры",
    exercises: [
      { type: "match-number-to-group", number: 2, options: [1, 2, 3] },
      { type: "match-group-to-number", count: 5, options: [3, 4, 5] },
      { type: "match-number-to-group", number: 1, options: [1, 2] },
      { type: "match-group-to-number", count: 4, options: [2, 3, 4, 5] },
      { type: "match-number-to-group", number: 3, options: [2, 3, 4] },
    ]
  },
  
  // Block 4: Add & Remove within 5
  {
    id: 10,
    blockId: 4,
    title: "Один пришёл",
    description: "Кубик приходит - становится больше",
    exercises: [
      { type: "animated-add", start: 1, add: 1, options: [2, 3] },
      { type: "animated-add", start: 2, add: 1, options: [2, 3, 4] },
      { type: "animated-add", start: 3, add: 1, options: [3, 4, 5] },
      { type: "animated-add", start: 1, add: 1, options: [1, 2, 3] },
      { type: "animated-add", start: 4, add: 1, options: [4, 5] },
    ]
  },
  {
    id: 11,
    blockId: 4,
    title: "Один ушёл",
    description: "Кубик уходит - становится меньше",
    exercises: [
      { type: "animated-remove", start: 2, remove: 1, options: [1, 2] },
      { type: "animated-remove", start: 3, remove: 1, options: [1, 2, 3] },
      { type: "animated-remove", start: 4, remove: 1, options: [2, 3, 4] },
      { type: "animated-remove", start: 5, remove: 1, options: [3, 4, 5] },
      { type: "animated-remove", start: 3, remove: 1, options: [1, 2, 3] },
    ]
  },
  {
    id: 12,
    blockId: 4,
    title: "Приходят и уходят",
    description: "Кубики приходят и уходят",
    exercises: [
      { type: "animated-add", start: 2, add: 2, options: [3, 4, 5] },
      { type: "animated-remove", start: 4, remove: 2, options: [1, 2, 3] },
      { type: "hidden-box", start: 3, change: 1, operation: "add", options: [3, 4, 5] },
      { type: "hidden-box", start: 5, change: 2, operation: "remove", options: [2, 3, 4] },
      { type: "animated-add", start: 1, add: 2, options: [2, 3, 4] },
    ]
  },
  
  // Block 5: Early Mental Math within 5
  {
    id: 13,
    blockId: 5,
    title: "Сложение в уме",
    description: "Складываем без кубиков",
    exercises: [
      { type: "mental-math", a: 1, b: 1, operation: "add", options: [1, 2, 3] },
      { type: "mental-math", a: 2, b: 1, operation: "add", options: [2, 3, 4] },
      { type: "mental-math", a: 2, b: 2, operation: "add", options: [3, 4, 5] },
      { type: "mental-math", a: 1, b: 2, operation: "add", options: [2, 3, 4] },
      { type: "mental-math", a: 3, b: 1, operation: "add", options: [3, 4, 5] },
    ]
  },
  {
    id: 14,
    blockId: 5,
    title: "Вычитание в уме",
    description: "Вычитаем без кубиков",
    exercises: [
      { type: "mental-math", a: 2, b: 1, operation: "subtract", options: [1, 2] },
      { type: "mental-math", a: 3, b: 1, operation: "subtract", options: [1, 2, 3] },
      { type: "mental-math", a: 4, b: 2, operation: "subtract", options: [1, 2, 3] },
      { type: "mental-math", a: 5, b: 1, operation: "subtract", options: [3, 4, 5] },
      { type: "mental-math", a: 5, b: 2, operation: "subtract", options: [2, 3, 4] },
    ]
  },
  {
    id: 15,
    blockId: 5,
    title: "Мастер счёта",
    description: "Всё вместе - ты молодец!",
    exercises: [
      { type: "mental-math", a: 2, b: 2, operation: "add", options: [3, 4, 5] },
      { type: "mental-math", a: 5, b: 3, operation: "subtract", options: [1, 2, 3] },
      { type: "hidden-box", start: 4, change: 1, operation: "add", options: [4, 5] },
      { type: "mental-math", a: 1, b: 3, operation: "add", options: [3, 4, 5] },
      { type: "mental-math", a: 4, b: 1, operation: "subtract", options: [2, 3, 4] },
    ]
  }
];

// Questions in Russian
export const QUESTIONS = {
  "see-and-choose": "Сколько здесь?",
  "match-group-to-number": "Какая это цифра?",
  "match-number-to-group": "Где столько же?",
  "compare-more": "Где больше?",
  "compare-less": "Где меньше?",
  "animated-add": "Сколько стало?",
  "animated-remove": "Сколько осталось?",
  "hidden-box": "Сколько теперь?",
  "mental-math-add": "Сколько будет?",
  "mental-math-subtract": "Сколько осталось?"
};

// Encouragement messages in Russian
export const ENCOURAGEMENTS = {
  correct: [
    "Молодец!",
    "Отлично!",
    "Правильно!",
    "Супер!",
    "Здорово!",
    "Умница!"
  ],
  incorrect: [
    "Попробуй ещё!",
    "Почти!",
    "Давай ещё раз!"
  ],
  lessonComplete: [
    "Урок окончен!",
    "Отличная работа!",
    "Ты справился!"
  ]
};

export const getBlockById = (blockId) => BLOCKS.find(b => b.id === blockId);
export const getLessonById = (lessonId) => LESSONS.find(l => l.id === lessonId);
export const getLessonsByBlock = (blockId) => LESSONS.filter(l => l.blockId === blockId);
export const getNextLesson = (currentLessonId) => LESSONS.find(l => l.id === currentLessonId + 1);
